import { defineComponent } from 'vue'
import { BlockModule } from '@/website/blocks/common'
import { Button } from '@/components/ui/button'

new BlockModule({
    selector: '.block-button',
    vueComponent: defineComponent({
        components: {
            ButtonComponent: Button,
        },
        setup() {},
    }),
})
